import React, { useState } from 'react';
import { ResetPasswordForm } from '../../../shared';
import { RouteComponentProps, Link } from 'react-router-dom';
import { useSessionFacade } from '../../store/hooks';
import { Alert, Button } from 'antd';

const ResetPassword: React.FC<RouteComponentProps> = ({ history }) => {
  const facade = useSessionFacade();
  const [status, setStatus] = useState<'success' | 'error' | undefined>();

  const handleSubmit = async (data: any) => {
    const res = await facade.restorePassword(data.email);

    setStatus(res.response ? 'success' : 'error');
  };

  const handleBackToLogin = () => {
    history.replace('/auth/login');
  };

  if (status === 'success') {
    return (
      <>
        <p>Activation link sent to your email address.</p>
        <Link to="/auth/login">
          <Button type="primary">Back to login</Button>
        </Link>
      </>
    );
  }

  return (
    <>
      {status === 'error' && (
        <Alert
          message="User with provided email is not found"
          type="error"
          showIcon
          style={{ marginBottom: '20px' }}
        />
      )}
      <ResetPasswordForm
        onBackToLogin={handleBackToLogin}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default ResetPassword;
